import "./App.css";
import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Certifications from "./components/Certifications";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
	const [isDarkMode, setIsDarkMode] = useState(() => {
		// Check localStorage first
		const saved = localStorage.getItem("theme");
		if (saved) return saved === "dark";
		// Fallback to system preference
		return window.matchMedia("(prefers-color-scheme: dark)").matches;
	});

	useEffect(() => {
		// Apply theme to document
		if (isDarkMode) {
			document.documentElement.classList.add("dark");
		} else {
			document.documentElement.classList.remove("dark");
		}
		// Save preference
		localStorage.setItem("theme", isDarkMode ? "dark" : "light");
	}, [isDarkMode]);

	const toggleTheme = () => setIsDarkMode(!isDarkMode);

	return (
		<>
			<Navbar isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
			<main className="page-container">
				<Hero />
				<About />
				<Experience />
				<Skills />
				<Education />
				<Projects />
				<Certifications />
				<Contact />
			</main>
			<Footer />
		</>
	);
}

export default App;
